import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardNotification } from '../../components';
import { getNotification } from '../../redux/actions/notificationActions';

const Notification = () => {
  const dispatch = useDispatch();

  const { notificaciones } = useSelector((state) => state.notificationReducer);
  useEffect(() => {
    dispatch(getNotification());
  }, []);

  return (
    <div>
      <CardNotification notificaciones={notificaciones} />
    </div>
  );
};

export default Notification;
